import React from "react";
import t from "babel-plugin-yate/macro";
import get from "lodash-es/get";
import { format } from "date-fns";

import { parseTimeLapsed } from "../lib/misc";

import statusMap from "../config/creditListStatus";

import RequestStatusLabel from "./RequestStatusLabel";

export const LendingRequestsListItem = ({ data }) => {
  let date = data.created_at && new Date(data.created_at);

  return (
    <>
      <div className="table-cell pl-2 pr-2 py-3 border-b">
        <div className="flex mb-1 align-center">
          <div className="mr-5">
            <RequestStatusLabel
              backgroundColor={statusMap(data?.status)?.badgeColor}
              title={statusMap(data?.status)?.text}
            />

            <div className="text-grey-darker-1 text-10 mt-1 uppercase">
              {t`${parseTimeLapsed(data.time_lapsed)} ago` || ""}
            </div>
          </div>

          <div style={{ maxWidth: "150px" }}>
            <div className="font-medium">
              {get(data, "customer_first_name", "---")} <br />
              {get(data, "customer_last_name", "---")}
            </div>

            <div className="text-grey-darker-1 mt-2">
              #{data.id} #{data?.created_by}
            </div>
          </div>
        </div>
      </div>
      <div className="table-cell align-top px-2 py-4 border-b">
        <div className="font-medium">{format(date, "dd.MM.yyyy")}</div>
        <div className="text-grey-darker-1">{format(date, "HH:mm")}</div>
      </div>
      <div className="table-cell align-top px-2 py-4 border-b font-medium">
        {get(data, "cnp", "---")}
      </div>
      <div className="table-cell align-top px-1 py-4 border-b font-medium">
        {get(data, "customer_phone", "---")}
      </div>
      <div className="table-cell align-top px-1 py-4 border-b font-medium">
        {get(data, "customer_email", "---")}
      </div>
      <div className="table-cell align-top px-1 py-4 border-b font-medium">
        {get(data, "contract_number", "---")}
      </div>
    </>
  );
};
